import React from 'react'

import Footer from "./Footer";

const Layout = () => {
  return (
    <div>
      
      <Footer/>
    </div>
  )
}

export default Layout
